import bridge from '../bridge/index'
import env from '../core/env'
import system from '../system'

let entranceCfg = {
  buttons: []
}

let appVersion = ''

// 司机端5.0.18 以上 ios不支持qq 支付宝渠道，先保持双端的一致性
let channelMaps = {
  weixin_timeline: {
    type: 'shareWeixinTimeline'
  },
  weixin_appmsg: {
    type: 'shareWeixinAppmsg'
  }
}

function internationalHandler (lang = 'zh-CN', cityId = '') {
  // lang处理
  switch (lang) {
  case 'zh-TW':
  case 'zh-HK':
    channelMaps = hktw
    break
  default:
    break
  }
  // city_id处理 香港357和台湾（台湾是个正则 886500xxx）
  let twReg = /^886500[0-9]{3}$/
  if (+cityId === 357 || twReg.test(+cityId)) {
    channelMaps = hktw
  }
  // ua 处理，司机端，香港台湾和 国内车主端不一致
  if (env.is('driverHK') || env.is('driverTW')) {
    channelMaps = hktw
  }
  return channelMaps
}

let hktw = {
  facebook: {
    type: 'shareFacebook'
  },
  messenger: {
    type: 'shareFBMessenger'
  },
  line: {
    type: 'shareLine'
  },
  whatsapp: {
    type: 'shareWhatsApp'
  }
}

function preShareCfg (cfg) {
  // ios11.2 分享有bug。暂时不用新的接口
  if (env.compare(appVersion, '>=', '5.0.18')) {
    let buttons = []
    let channelMaps = internationalHandler(cfg.lang, cfg.city_id)
    for (let channel in channelMaps) {
      let channelCfg = channelMaps[channel]
      let data = {}
      if (cfg[channel] === false) {
        continue
      }
      if (channel === 'shareSMS') {
        data = {
          phone: cfg.phone,
          content: cfg[channel + '_content'] || cfg.content
        }
      } else {
        data = {
          url: cfg.url,
          icon: cfg.icon,
          title: cfg[channel + '_title'] || cfg.title,
          content: cfg[channel + '_content'] || cfg.content
        }
      }

      buttons.push({
        type: channelCfg.type,
        name: channelCfg.name,
        data: data
      })
    }
    // 司机端木有刷新
    if (cfg.refresh !== false) {
      buttons.push({
        type: 'refreshPage',
        data: {}
      })
    }
    entranceCfg.buttons = buttons
    return entranceCfg
  } else {
    let opts = {}
    opts.share_url = cfg.url
    opts.share_content = cfg.content
    opts.share_title = cfg.title
    opts.share_icon_url = cfg.icon
    let driverShareData = {
      share_weixin_appmsg: opts,
      share_weixin_timeline: opts
    }
    if (cfg.sms !== false) {
      driverShareData['share_sms'] = {
        phone: cfg.phone || '',
        content: cfg.sms_content || cfg.content
      }
    }
    return driverShareData
  }
}

export function setShare (cfg) {
  if (cfg === false) {
    // 司机端暂时不支持 刷新或者 隐藏
    bridge.addCornerButton(
      {
        btnName: ''
      },
      function () {
        console.log('隐藏')
      }
    )
  } else {
    let driverShareData = {}
    if (appVersion) {
      driverShareData = preShareCfg(cfg)
      setEntrance(driverShareData)
    } else {
      system.getSystemInfo(function ({ appverison }) {
        appVersion = appverison
        driverShareData = preShareCfg(cfg)
        setEntrance(driverShareData)
      })
    }
  }
}

function setEntrance (driverShareData) {
  // 加个100ms 试试
  setTimeout(function () {
    bridge.initEntrance(driverShareData)

    // 司机端默认右上角无操作按钮，手动添加
    bridge.addCornerButton(
      {
        btnName: '...'
      },
      function () {
        bridge.invokeEntrance()
      }
    )
  }, 100)
}

export function invokeShare (channel, cfg) {
  let allowed =
    'weixin_timeline,weixin_appmsg,share_sms,facebook,messenger,line,whatsapp'

  if (allowed.indexOf(channel) !== -1) {
    bridge.share(channel, cfg)
  }
}
